// STEPS
export const CLASIFICACION_STEP: string = 'classification';
export const DATOS_PRINCIPALES_STEP: string = 'data';
export const AUTORES_STEP: string = 'authors';
export const INFORMACION_STEP: string = 'info';
export const CONTEXTO_STEP: string = 'context';
export const FICHEROS_STEP: string = 'files';
export const UBICACIONES_STEP: string = 'locations';
export const LOANS_STEP: string = 'loans';
export const BOUDS_STEP: string = 'bouds';
export const LOANS_HISTORY_STEP: string = 'loans-history';
// CLASIFICACION_STEP
export const FONDO_FIELD: string = 'fund';
export const GRUPO_CLASIFICACION_FIELD: string = 'classificationGroup';
export const CLASIFICACION_FIELD: string = 'classification';
export const DIVISION_FIELD: string = 'division';
export const SUBDIVISION_FIELD: string = 'subdivision';
export const SUBDIVISION_ESP_FIELD: string = 'specificSubdivision';
export const SUBDIVISION_NOM_FIELD: string = 'nominalSubdivision';

// DATOS_PRINCIPALES_STEP
export const CATEGORIA_FIELD: string = 'category';
export const TIPOLOGIA_FIELD: string = 'typology';
export const TITULO_FIELD: string = 'title';
export const DEPOSITO_PROVISIONAL_FIELD: string = 'depositProv';
export const NIVEL_DESC_FIELD: string = 'descLevel';
export const FECHA_INICIO_FIELD: string = 'startDate';
export const FECHA_FIN_FIELD: string = 'endDate';
export const VOLUMEN_SOP_FIELD: string = 'supportVolume';

// INFORMACION_STEP
export const ALCANCE_CONTENIDO_FIELD: string = 'scopeContent';
export const DESCRIPTORES_FIELD: string = 'descriptors';
export const TESAURO_FIELD: string = 'thesaurus';

// CONTEXTO_STEP
export const VALORACION_FIELD: string = 'valuation';
export const ACCESO_FIELD: string = 'access';
export const LOCALIZACION_FIELD: string = 'location';
export const REPRODUCCION_FIELD: string = 'reproduction';
export const LENGUA_FIELD: string = 'language';
export const DOCUMENTOS_ASOCIADOS_FIELD: string = 'associatedDocuments';
export const CONSERVACION_FIELD: string = 'conservation';
export const NOTAS_FIELD: string = 'notes';

// FICHEROS_STEP
export const FILES_FIELD: string = 'files';

// UBICACIONES_STEP
export const LOCATIONS_FIELD: string = 'locations';

// AUTORES_STEP
export const AUTHORS_FIELD: string = 'authors';

// LOANS_STEP
export const LOANS_FIELD: string = 'loans';

// LOANS_HISTORY_STEP
export const LOANS_HISTORY_FIELD: string = 'loans-history';

// BOUDS_STEP
export const BOUDS_FIELD: string = 'bouds';

export const RECORD_WATERMARK_TEXT: string = "ARCHIVO UNIVERSITARIO UD"